<div class="float-right">
  <sh-button *ngIf="!showAddCommentDiv" shape="pill-m" color="secondary" label='Add Comment' id="addComment"
    class="add-comment" (click)="showAddComment()"></sh-button>
  </div>
<div columns="12" *ngIf="showAddCommentDiv">
  <sh-input-text label='Subject' id="commentSubject" [(value)]="newComment.subject"
    (value-changed)="newComment.subject=$event.target.value" [error]="commentSubjectError"
    (blur)="commentSubjectError = (newComment.subject === '' || newComment.subject.trim() === '')">
  </sh-input-text>
  <br />
  <sh-tooltip *ngIf="commentSubjectError" label="Please enter the Comment Subject" target="commentSubject"
    placement="bottom-right" variation="short"></sh-tooltip>
  <sh-input-text label='Comment' textarea="true" id="commentDescription" [(value)]="newComment.description"
    (value-changed)="newComment.description=$event.target.value" [error]="commentDescriptionError"
    [error]="commentDescriptionError"
    (blur)="commentDescriptionError = (newComment.description === '' || newComment.description.trim() === '')">
  </sh-input-text>
  <sh-tooltip *ngIf="commentDescriptionError" label="Please enter the Comment Description" target="commentDescription"
    placement="bottom-right" variation="short"></sh-tooltip>
  <div columns="12" class="float-right">
    <div class="float-right comment-div">
      <sh-grid>
        <sh-button shape="pill-s" color="secondary" label='Cancel' columns="5" id="cancel"
          (click)="showAddCommentDiv=false"></sh-button>
        <sh-button shape="pill-s" label='Add' id="add" columns="7" 
        (click)="addComment()" onclick="document.querySelector('#comment-added').visible = true" >
        </sh-button>
      </sh-grid>
    </div>
  </div>
</div>
  <sh-notification class="comment-notify">
    <sh-notification-item id="comment-added" duration="short" [visible] 
      type="confirmation"
      label="Success">
      Comment Added!
    </sh-notification-item>
</sh-notification>
<div *ngIf="asset && asset.comments && asset.comments.length > 0">
  <div columns="12" *ngFor="let comment of asset.comments; let i= index">
    <div columns="12" *ngIf="comment.displayEdit">
      <sh-input-text label='Subject' id="commentSubject" [value]="comment.subject"
        (value-changed)="comment.subject=$event.target.value !== ''? $event.target.value: comment.subject"
        [error]="commentSubjectError"
        (blur)="commentSubjectError = (comment.subject === '' || comment.subject.trim() === '')">
      </sh-input-text>
      <br />
      <sh-tooltip *ngIf="commentSubjectError" label="Please enter the Comment Subject" target="commentSubject"
        placement="bottom-right" variation="short"></sh-tooltip>
      <sh-input-text label='Comment' textarea="true" id="commentDescription" [value]="comment.description"
        (value-changed)="comment.description=$event.target.value !== ''? $event.target.value: comment.description"
        [error]="commentDescriptionError" [error]="commentDescriptionError"
        (blur)="commentDescriptionError = (comment.description === '' || comment.description.trim() === '')">
      </sh-input-text>
      <sh-tooltip *ngIf="commentDescriptionError" label="Please enter the Comment Description"
        target="commentDescription" placement="bottom-right" variation="short"></sh-tooltip>
      <div columns="12" class="float-right">
        <div class="float-right comment-div">
          <sh-grid>
            <sh-button shape="pill-s" color="secondary" label='Cancel' columns="5" id="cancel"
              (click)="toggledEdit(comment)"></sh-button>
            <sh-button shape="pill-s" label='Update' id="update" columns="7" 
             (click)="submitEditComment(comment)" onclick="document.querySelector('#comment-updated').visible = true">
            </sh-button>
          </sh-grid>
        </div>
      </div>
    </div>
    <sh-notification class="comment-notify">
      <sh-notification-item id="comment-updated" duration="short" [visible] 
      type="confirmation"
      label="Success">
      Comment Updated.
      </sh-notification-item>
    </sh-notification>
   

    <sh-grid *ngIf="!comment.displayEdit">
      <div columns="1">
        <sh-user-identifier [image]="'url(' + comment.commenterProfile + ')'" slot='user'></sh-user-identifier>
      </div>
      <div columns="11">
        <sh-text class="font-header-2"> <b>{{ comment.subject }}</b></sh-text>
        <br>
        <!-- <sh-grid> -->
        <div class="float-left">
          <sh-text class="font-title-2" *ngIf="comment.userName; else userEmail">
            {{ comment.userName }} | Commented for Version {{ comment.forAssetVersion }}
          </sh-text>
          <ng-template #userEmail>
            <sh-text class="font-title-2">
              {{ comment.createdByUser }}
            </sh-text>
          </ng-template>
        </div>
        <div class="float-right">
          <!-- <sh-text style="font:var(--heaser-2); float: right">{{ comment.createdOn | date}}</sh-text> -->
          <sh-text class="float-right font-heaser-2">{{ comment.createdOn | dateToInterval }}</sh-text>
          <!-- pipe is required -->
        </div>
        <br>
        <!-- </sh-grid> -->
        <sh-text class="font-body-2">{{ comment.description }}</sh-text>
        <sh-grid>
          <div *ngIf="userService.loggendInUser.userEmailId === comment.createdByUser" class="display-inline">
            <sh-icon button color="secondary" icon="edit" class="edit-comment" id="editComment"
              (click)="toggledEdit(comment)"></sh-icon>
            <sh-icon button color="secondary" icon="delete" class="delete-comment"
              id="DeleteComment" onclick="document.querySelector('#comment-delete').visible = true"></sh-icon>
              <sh-modal class="notify-modal" sticky icon="warning" id="comment-delete" label='Warning' modal-height='200px' modal-width='320px'>
                Are you sure you want to delete the comment? 
                <sh-button color='secondary' slot='footer' label='Cancel' onclick="document.querySelector('#comment-delete').visible = false"></sh-button>
                <sh-button slot='footer' label='Yes' (click)="deleteComment(comment)"></sh-button>
            </sh-modal>
            </div><br><br>
          </sh-grid>

        
      </div>
    </sh-grid>
    <sh-divider *ngIf="i !== asset.comments.length - 1"></sh-divider>
  </div>
</div>

<sh-text class="text-align-center" *ngIf="!asset?.comments || asset.comments.length === 0">
  No comments yet
</sh-text>

